import React from 'react';
import Hint from './Hint';

export interface CharacterCountMessageProps {
  characterCountMax: number;
  characterCount: number;
  className?: string;
  id: string;
}

const CharacterCountMessage = ({
  characterCount,
  characterCountMax,
  className,
  id,
}: CharacterCountMessageProps): JSX.Element => {
  const invalid = characterCount > characterCountMax;
  const message = invalid
    ? `${characterCount - characterCountMax} characters over limit`
    : `${characterCountMax - characterCount} characters left`;
  return (
    <Hint id={id} className={className} variant="characterCount" invalid={invalid}>
      {message}
    </Hint>
  );
};

export default CharacterCountMessage;
